import { render, staticRenderFns } from "./ModalRole.vue?vue&type=template&id=7b266c35"
import script from "./ModalRole.vue?vue&type=script&lang=js"
export * from "./ModalRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports